/* global process */
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'

import localStorage from './local_storage'
import GameSwitcher from './game_switcher'
import patchedWebToClient from './web_to_client'


const customMiddlewares = [
    thunk,
    localStorage,
    GameSwitcher,
    patchedWebToClient,
]

if (process.env.NODE_ENV === 'development') {
    const logger = createLogger({ collapsed: true })
    customMiddlewares.push(logger)
}

export default function getMiddlewares(history) {
    return [...customMiddlewares, routerMiddleware(history)]
}



// WEBPACK FOOTER //
// ./state/middlewares/index.js